import React from 'react';
import { Outlet } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import SharedNavbar from '../SharedNavbar/SharedNavbar';
import Footer from '../Footer/Footer.tsx';

function Layout() {
  return (
    <Container fluid className="d-flex flex-column min-vh-100">
      <Row id="navigation_container" className='flex-nowrap'>
        <SharedNavbar />
      </Row>
      <div className="flex-grow-1">
        <Outlet />
      </div>
      <Row className="flex-nowrap">
        <Footer />
      </Row>
    </Container>
  );
}

export default Layout;
